/**
 * Type-safe notification translation keys.
 * Use these constants to ensure consistency between backend text and frontend translations.
 */
export const NOTIFICATION_KEYS = {
  // Email verification
  EMAIL_VERIFICATION_REMINDER: "emailVerification.reminder",
  EMAIL_VERIFICATION_SUCCESS: "emailVerification.success",

  // CTA buttons
  CTA_VERIFY: "cta.verify",
  CTA_VERIFIED: "cta.verified",
  CTA_TRY_AGAIN: "cta.tryAgainIn",
  CTA_LOADING: "cta.loading",

  // Toast messages
  TOAST_VERIFICATION_EMAIL_SENT: "toast.verificationEmailSent",
} as const;

export type NotificationKey = (typeof NOTIFICATION_KEYS)[keyof typeof NOTIFICATION_KEYS];
